import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AddMoodComponent } from './add-comment/add-mood/add-mood.component';
import { TmMoodPickersComponent } from '../shared/ui/moodpickers/mood-pickers.component';
import { AddCommentComponent } from './add-comment/add-comment.component';
import { GifPreviewComponent } from '../shared/ui/gifpreview/gifpreview';
import { LinkPreviewComponent } from '../shared/ui/linkpreview/linkpreview';
import { AddOtherFeedbackComponent } from './add-other-feedback/add-other-feedback.component';
import { UserRequestsComponent } from "../timeline/user-requests/user-requests.component";
import { AddPollCommentComponent } from "./add-poll-comment/add-poll-comment.component";
import { TmPipesModule } from "../shared/util/pipes";
import { TmRichTextAreaComponent } from "../shared/ui/rich-text-area/rich-text-area.component";
import { RouterLink } from "@angular/router";
import { ChooseMoodComponent } from "./choose-mood/choose-mood.component";

@NgModule({
    declarations: [
        AddCommentComponent,
        AddMoodComponent,
        AddOtherFeedbackComponent,
        AddPollCommentComponent,
        ChooseMoodComponent
      ],
    imports: [
        CommonModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        TmMoodPickersComponent,
        GifPreviewComponent,
        LinkPreviewComponent,
        UserRequestsComponent,
        TmPipesModule,
        TmRichTextAreaComponent,
        RouterLink
    ]
})
export class TmAddFeedbackModule {}
